(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  var shopifyLocale = ((window.Shopify && window.Shopify.locale) || '').toLowerCase();
  var isPolish = lang.indexOf('pl') === 0 || shopifyLocale.indexOf('pl') === 0 || window.location.pathname.indexOf('/pl') === 0;

  if (!isPolish) return;

  // Trustoo inserts controls asynchronously and splits labels across text nodes.
  // Translate widget UI only; customer reviews and form values remain untouched.
  var reviewRootSelector = '.trustoo-widget, #trustoo-mask, #trustoo-review-detail, #tt-carousel-content';
  var reviewContentSelector = '.reviews-text, .tt-bs-text, .tt-card-review, .review-content, .review-author, .user-name, .tt-review-avatar, [translate="no"], [contenteditable="true"]';
  var reviewText = {
    'Mūsų klientai mus myli': 'Nasi klienci nas uwielbiają',
    'Rūšiuoti pagal': 'Sortuj według',
    'Rekomenduojami': 'Polecane',
    'Nuotraukų prioritetas': 'Najpierw ze zdjęciami',
    'Aukščiausi įvertinimai': 'Najwyższe oceny',
    'Žemiausi įvertinimai': 'Najniższe oceny',
    'Įvertinimas': 'Ocena',
    'Apžvalga': 'Opinia',
    'Tavo atsiliepimas': 'Twoja opinia',
    'Tavo vardas': 'Twoje imię',
    'Jūsų vardas': 'Twoje imię',
    'Tavo elektroninis paštas': 'Twój adres e-mail',
    'El. paštas': 'Adres e-mail',
    'Telefono numeris': 'Numer telefonu',
    'Pridėti nuotrauką': 'Dodaj zdjęcie',
    'Pridėti vaizdo įrašą': 'Dodaj film',
    'Pridėti nuotrauką ar vaizdo įrašą': 'Dodaj zdjęcie lub film',
    'Pateikite apžvalgą': 'Wyślij opinię',
    'Užpildykite šį lauką': 'Wypełnij to pole',
    'Tai netinkamas el. pašto formatas': 'Wpisz prawidłowy adres e-mail',
    'Atsiprašome, kažkas nutiko, bandykite dar kartą vėliau': 'Coś poszło nie tak. Spróbuj ponownie później.',
    'Įkėlimas sustabdytas, aptiktas nepalaikomas failas.': 'Przesyłanie zostało zatrzymane. Ten format pliku nie jest obsługiwany.',
    'Įkeliama. Prašome pateikti po užbaigimo.': 'Trwa przesyłanie. Wyślij opinię po jego zakończeniu.',
    'Įkeliama': 'Przesyłanie',
    'pateikiant': 'Wysyłanie',
    'Jūsų apžvalga išsiųsta': 'Twoja opinia została wysłana',
    'Jūsų atsiliepimas išsiųstas!': 'Twoja opinia została wysłana!',
    'Ačiū!': 'Dziękujemy!',
    'Dėkojame už jūsų atsiliepimą': 'Dziękujemy za Twoją opinię',
    'Tęsti': 'Kontynuuj',
    'Atgal': 'Wstecz',
    'Kitas': 'Dalej',
    'Toliau': 'Dalej',
    'Praleisti': 'Pomiń',
    'Uždaryti': 'Zamknij',
    'Atlikta': 'Gotowe',
    'Kopijuoti': 'Kopiuj',
    'Nukopijuota sėkmingai': 'Skopiowano',
    'Daugiau': 'Więcej',
    'Rodyti visą apžvalgą': 'Pokaż całą opinię',
    'Naudinga?': 'Pomocna?',
    'Ar tai buvo naudinga?': 'Czy to było pomocne?',
    'Ar tai vieša?': 'Czy opinia ma być publiczna?',
    'Taip': 'Tak',
    'Ne': 'Nie',
    'Arba': 'Lub',
    'Ne, ačiū': 'Nie, dziękuję',
    'Pasidalinkite savo patirtimi': 'Podziel się swoim doświadczeniem',
    'Papasakok daugiau!': 'Opowiedz więcej!',
    'Apie tave': 'O Tobie',
    'Kaip įvertintumėte šį elementą?': 'Jak oceniasz ten produkt?',
    'Pasirinkti produktą': 'Wybierz produkt',
    'Ieškoti produktų pagal pavadinimą...': 'Szukaj produktów według nazwy...',
    'Pasirinkite viską, kas tinka': 'Zaznacz wszystkie pasujące odpowiedzi',
    'Pasirinkite vieną': 'Wybierz jedną odpowiedź',
    'Pirmiausia įsigykite produktą.': 'Najpierw kup ten produkt.',
    'Kol kas atsiliepimų nėra.': 'Nie ma jeszcze opinii.',
    'Kol kas nėra klausimų.': 'Nie ma jeszcze pytań.',
    'Ką tik': 'Przed chwilą',
    'Privatumo politika': 'Polityka prywatności',
    'Sąlygos': 'Warunki',
    'Žiūrėti kitus produktus': 'Zobacz inne produkty',
    'Naudoti nuolaidas': 'Wykorzystaj rabat'
  };

  function isReviewUI(element) {
    return element && element.closest && element.closest(reviewRootSelector) && !element.closest(reviewContentSelector);
  }

  function translateReviewText(value, element) {
    if (!value || !isReviewUI(element)) return value;
    var trimmed = value.trim();
    if (element.closest('#tt-protection')) {
      var consentText = {
        'Pateikdami šį atsiliepimą, sutinkate su CWILL': 'Przesyłając tę opinię, wyrażasz zgodę na przetwarzanie swoich danych osobowych przez CWILL zgodnie z',
        'Privatumo politika': 'Polityką prywatności',
        'Sąlygos': 'Warunkami',
        'ir': 'i',
        'dėl jūsų asmeninių duomenų tvarkymo.': '.'
      };
      if (consentText[trimmed]) return trimmed === 'dėl jūsų asmeninių duomenų tvarkymo.' ? '.' : value.replace(trimmed, consentText[trimmed]);
    }
    if (element.closest('#tt-carousel-desc')) {
      return value.replace(/žvaigždutės remiantis/g, 'na 5 na podstawie').replace(/atsiliepimais/g, 'opinii');
    }
    if (reviewText[trimmed]) return value.replace(trimmed, reviewText[trimmed]);
    return value
      .replace(/Apžvalgos(?=\s*\()/g, 'Opinie')
      .replace(/prieš\s+(\d+)\s+mėnesį/g, '$1 mies. temu')
      .replace(/Pridėkite nuotrauką ir gaukite\s+(\d+(?:[.,]\d+)?%)\s+nuolaidą kitam pirkiniui!/g, 'Dodaj zdjęcie i otrzymaj $1 rabatu na następny zakup!');
  }

  function translateSplitReviewLabels(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.star-classify [data-tt-lang-path="stars|star"], .star-classify [data-tt-lang-path="star"]').forEach(function (element) {
      if (!isReviewUI(element)) return;
      var number = element.parentElement.querySelector('.number');
      var count = number ? Number(number.textContent.trim()) : 0;
      var next = count === 1 ? 'gwiazdka' : count >= 2 && count <= 4 ? 'gwiazdki' : 'gwiazdek';
      if (element.textContent !== next) element.textContent = next;
    });
  }

  function translateReviewCounts(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('.reviews-num [data-tt-lang-path="reviews"]').forEach(function (element) {
      if (!isReviewUI(element)) return;
      var match = element.parentElement.textContent.trim().match(/^(\d+)/);
      if (!match) return;
      var count = Number(match[1]);
      var next = count === 1 ? 'opinia' : count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 12 || count % 100 > 14) ? 'opinie' : 'opinii';
      if (element.textContent !== next) element.textContent = next;
    });
  }

  var exactText = {
    'Klientų atsiliepimai': 'Opinie klientów',
    'Atsiliepimai': 'Opinie',
    'atsiliepimai': 'opinie',
    'apžvalgos': 'opinie',
    'Parašyti atsiliepimą': 'Napisz opinię',
    'Parašyti parduotuvės atsiliepimą': 'Napisz opinię o sklepie',
    'Patvirtintas pirkinys': 'Zweryfikowany zakup',
    'Patvirtintas pirkimas': 'Zweryfikowany zakup',
    'Apžvalgos': 'Opinie',
    'Parduotuvės atsiliepimai': 'Opinie o sklepie',
    'Naujausias': 'Najnowsze',
    'Elemento tipas': 'Typ elementu',
    'Elemento tipas:': 'Typ elementu:',
    'Pirkėjai rodo': 'Kupujący pokazują',
    'Sutinku su': 'Zgadzam się z',
    'Pirkimo sąlygos ir taisyklės': 'Regulaminem zakupów',
    'Naudojimo sąlygos': 'Regulamin zakupów',
    'Naudojimo Sąlygos': 'Regulamin zakupów',
    'Pasirinktas paštomatas': 'Wybrany automat paczkowy',
    'Paštomato adresą perkelsime į atsiskaitymą.': 'Adres automatu paczkowego przeniesiemy do kasy.',
    'Pakuotė': 'Opakowanie',
    'Popierinis worek': 'Torba papierowa',
    'Papierinis worek': 'Torba papierowa',
    'Papierinis maišelis': 'Torba papierowa',
    'Papierinis maišas': 'Torba papierowa',
    'Popierinis maišelis': 'Torba papierowa',
    'Popierinis maišas': 'Torba papierowa',
    'Metalinė dėžutė': 'Metalowa skrzynka',
    'Metalinė dėžė': 'Metalowa skrzynka',
    '„Šiltesnis, sodresnis kvapas vakarui, progoms ir ryškesniam įspūdžiui.“': '„Cieplejszy, bardziej wyrazisty zapach na wieczór, okazje i mocniejsze wrażenie.”',
    '5 Žvaigždė': '5 gwiazdek',
    '4 Žvaigždė': '4 gwiazdki',
    '3 Žvaigždė': '3 gwiazdki',
    '2 Žvaigždė': '2 gwiazdki',
    '1 Žvaigždė': '1 gwiazdka',
  };

  var storefrontText = {
  "Dušiukas – Laimai, citrinos, levandos, šaltmėtės": "Dušiukas – limonka, cytryna, lawenda, mięta",
  "Plaukutis – Bergamotės, greipfrutai, ylang-ylang": "Plaukutis – bergamotka, grejpfrut, ylang-ylang",
  "Dušiukas Jasmine – Jazminas, mėtinė bergamotė": "Dušiukas Jasmine – jaśmin, miętowa bergamotka",
  "Dušiukas Jasmine – Jazminas, ylang-ylang": "Dušiukas Jasmine – jaśmin, ylang-ylang",
  "Plaukutis Jasmine – Jazminas, apelsinas, mandarinas": "Plaukutis Jasmine – jaśmin, pomarańcza, mandarynka",
  "Plaukutis – Levandos, bergamotės, pačiuliai, juodieji pipirai": "Plaukutis – lawenda, bergamotka, paczula, czarny pieprz",
  "Pilno ritualo ketvertas: zawartość zestawu": "Kwartet pełnego rytuału: zawartość zestawu",
  "Dušo pabėgimo kvartetas: zawartość zestawu": "Prysznicowy kwartet: zawartość zestawu",
  "Plaukų dienų kolekcija: zawartość zestawu": "Kolekcja dobrych dni dla włosów: zawartość zestawu",
  "Mitų kvartetas: zapachy w zestawie": "Kwartet mitów: zapachy w zestawie",
  "Audrų panteonas: zapachy w zestawie": "Panteon burz: zapachy w zestawie",
  "Didžioji mitų kolekcija: zapachy w zestawie": "Wielka kolekcja mitów: zapachy w zestawie",
  "Deivių ketvertas: zapachy w zestawie": "Kwartet bogiń: zapachy w zestawie",
  "Olimpo draugija: zapachy w zestawie": "Towarzystwo Olimpu: zapachy w zestawie",
  "Septynios legendos: zapachy w zestawie": "Siedem legend: zapachy w zestawie",
  "Kietie Mydła": "Mydła w kostce",
  "Kietie mydła": "Mydła w kostce",
  "Pirkėjai rodo": "Kupujący pokazują"
};

  function translateText(value) {
    if (!value || !value.trim()) return value;

    var trimmed = value.trim();
    var translated = exactText[trimmed];
    if (translated) {
      return value.replace(trimmed, translated);
    }

    var next = value;
    Object.keys(storefrontText).forEach(function (source) {
      next = next.split(source).join(storefrontText[source]);
    });
    next = next.replace(/Pakuotė/g, 'Opakowanie');
    next = next.replace(/pakuotė/g, 'opakowanie');
    next = next.replace(/Popierinis worek/g, 'Torba papierowa');
    next = next.replace(/popierinis worek/g, 'torba papierowa');
    next = next.replace(/Papierinis worek/g, 'Torba papierowa');
    next = next.replace(/papierinis worek/g, 'torba papierowa');
    next = next.replace(/Papierinis maišelis/g, 'Torba papierowa');
    next = next.replace(/papierinis maišelis/g, 'torba papierowa');
    next = next.replace(/Papierinis maišas/g, 'Torba papierowa');
    next = next.replace(/papierinis maišas/g, 'torba papierowa');
    next = next.replace(/Popierinis maišelis/g, 'Torba papierowa');
    next = next.replace(/popierinis maišelis/g, 'torba papierowa');
    next = next.replace(/Popierinis maišas/g, 'Torba papierowa');
    next = next.replace(/popierinis maišas/g, 'torba papierowa');
    next = next.replace(/Metalinė dėžutė/g, 'Metalowa skrzynka');
    next = next.replace(/metalinė dėžutė/g, 'metalowa skrzynka');
    next = next.replace(/Metalinė dėžė/g, 'Metalowa skrzynka');
    next = next.replace(/metalinė dėžė/g, 'metalowa skrzynka');
    next = next.replace(
      /„Šiltesnis, sodresnis kvapas vakarui, progoms ir ryškesniam įspūdžiui.“/g,
      '„Cieplejszy, bardziej wyrazisty zapach na wieczór, okazje i mocniejsze wrażenie.”'
    );
    next = next.replace(/(\d+)\s+apžvalgos/gi, '$1 opinii');
    next = next.replace(/(\d+)\s+Atsiliepimai/g, '$1 opinii');
    next = next.replace(/(\d+)\s+atsiliepimai/g, '$1 opinii');
    next = next.replace(/Apžvalgos\s*\((\d+)\)/g, 'Opinie ($1)');
    next = next.replace(/Parduotuvės atsiliepimai\s*\((\d+)\)/g, 'Opinie o sklepie ($1)');
    next = next.replace(/Parašyti parduotuvės atsiliepimą/g, 'Napisz opinię o sklepie');
    next = next.replace(/Naujausias/g, 'Najnowsze');
    next = next.replace(/Elemento tipas:/g, 'Typ elementu:');
    next = next.replace(/Elemento tipas/g, 'Typ elementu');
    next = next.replace(/Sutinku su/g, 'Zgadzam się z');
    next = next.replace(/Pirkimo sąlygos ir taisyklės/g, 'Regulaminem zakupów');
    next = next.replace(/Naudojimo sąlygos/g, 'Regulamin zakupów');
    next = next.replace(/Naudojimo Sąlygos/g, 'Regulamin zakupów');
    next = next.replace(
      /Pasirinktas paštomatas:\s*([^.]+)\.\s*Paštomato adresą perkelsime į atsiskaitymą\./g,
      'Wybrany automat paczkowy: $1. Adres automatu paczkowego przeniesiemy do kasy.'
    );
    next = next.replace(/Pasirinktas paštomatas:/g, 'Wybrany automat paczkowy:');
    next = next.replace(/Paštomato adresą perkelsime į atsiskaitymą\./g, 'Adres automatu paczkowego przeniesiemy do kasy.');
    next = next.replace(/prieš\s+1\s+dieną/gi, '1 dzień temu');
    next = next.replace(/prieš\s+(\d+)\s+dienas?/gi, '$1 dni temu');
    next = next.replace(/prieš\s+1\s+valandą/gi, '1 godz. temu');
    next = next.replace(/prieš\s+(\d+)\s+valandas?/gi, '$1 godz. temu');
    next = next.replace(/prieš\s+1\s+minutę/gi, '1 min temu');
    next = next.replace(/prieš\s+(\d+)\s+minutes?/gi, '$1 min temu');
    next = next.replace(/prieš\s+1\s+savaitę/gi, '1 tydz. temu');
    next = next.replace(/prieš\s+(\d+)\s+savaites?/gi, '$1 tyg. temu');
    next = next.replace(/prieš\s+(\d+)\s+mėnesius?/gi, '$1 mies. temu');
    next = next.replace(/prieš\s+mėnesį/gi, 'miesiąc temu');
    next = next.replace(/prieš\s+1\s+metus?/gi, '1 rok temu');
    next = next.replace(/prieš\s+(\d+)\s+metus?/gi, '$1 lat temu');
    next = next.replace(/5\s+Žvaigždė/g, '5 gwiazdek');
    next = next.replace(/4\s+Žvaigždė/g, '4 gwiazdki');
    next = next.replace(/3\s+Žvaigždė/g, '3 gwiazdki');
    next = next.replace(/2\s+Žvaigždė/g, '2 gwiazdki');
    next = next.replace(/1\s+Žvaigždė/g, '1 gwiazdka');
    return next;
  }

  function shouldSkipElement(element) {
    if (!element || !element.tagName) return false;
    return /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION)$/.test(element.tagName) || Boolean(element.closest(reviewContentSelector));
  }

  function translateAttributes(element) {
    ['aria-label', 'title', 'placeholder'].forEach(function (attribute) {
      if (!element.hasAttribute || !element.hasAttribute(attribute)) return;
      var current = element.getAttribute(attribute);
      var next = translateText(translateReviewText(current, element));
      if (next !== current) {
        element.setAttribute(attribute, next);
      }
    });
  }

  function translateNode(node) {
    if (!node || !node.parentElement || shouldSkipElement(node.parentElement)) return;
    var next = translateText(translateReviewText(node.nodeValue, node.parentElement));
    if (next !== node.nodeValue) {
      node.nodeValue = next;
    }
  }

  function translateRoot(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      translateNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && shouldSkipElement(root)) return;

    if (root.nodeType === Node.ELEMENT_NODE) {
      translateAttributes(root);
    }

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        return node.parentElement && !shouldSkipElement(node.parentElement)
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    });

    var nodes = [];
    var current;
    while ((current = walker.nextNode())) {
      nodes.push(current);
    }
    nodes.forEach(translateNode);

    if (root.querySelectorAll) {
      root.querySelectorAll('[aria-label], [title], [placeholder]').forEach(translateAttributes);
      translateSplitReviewLabels(root);
      translateReviewCounts(root);
    }
  }

  var scheduled = false;
  function scheduleTranslate(root) {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(function () {
      scheduled = false;
      translateRoot(root || document.body);
    }, 80);
  }

  function start() {
    translateRoot(document.body);
    [300, 1000, 2500, 5000].forEach(function (delay) {
      window.setTimeout(function () {
        translateRoot(document.body);
      }, delay);
    });

    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].target) {
          scheduleTranslate(document.body);
          break;
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['placeholder', 'aria-label', 'title'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
